import { ScreenSplitMode } from 'shared-types/ScreenSplit';

import { BamSessionMode, QUARTER_HOURS_COUNTS, SessionState } from './types';

export const sessionInitialState: SessionState = {
  endTimestamp: null,
  remainingSessionTimeInMilliseconds: null,
  activatedVolume: false,
  shouldSkipStaffPassword: false,
  screenSplitMode: ScreenSplitMode.DISABLED,
  isStorageActivated: false,
  bamSessionMode: BamSessionMode.AUTO,
  customPlaylists: null,
  bamSessionUser: {
    clientCode: null,
    firstName: null,
    lastName: null,
    email: null,
    bamCustomerId: null,
    sessionStarted: false,
  },
  bamProlongation: {
    isProlongationPossiblePerTimeBlock: {
      [QUARTER_HOURS_COUNTS.THIRTY_MINUTES]: false,
      [QUARTER_HOURS_COUNTS.ONE_HOUR]: false,
      [QUARTER_HOURS_COUNTS.TWO_HOURS]: false,
    },
    isProlongationStateWaitingForChange: false,
    currentPricePerHour: null,
  },
  isVideoRecording: false,
};
